import React from 'react';
import useAddToCompanyDialog from '../../hooks/useAddToCompanyDialog';
import useUserSWR from '../../hooks/user/useUserSWR';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const MyCompany = () => {
    const { user, isLoading, isError, forceRefresh } = useUserSWR();
    const { t } = useTranslation();

    const addToCompanyDialog = useAddToCompanyDialog();

    const handleAddToCompanyClick = () => {
        addToCompanyDialog.showDialog(
            true,
            user.bc_company_number.toString(),
            user.company,
            false
        );
    };

    return (
        <Box>
            <Box sx={{ padding: '20px 0' }}>
                <Typography variant="h2">
                    {t('PROFILE.COMPANY.TITLE')}
                </Typography>
            </Box>
            {!isLoading && !isError && (
                <Box sx={{ paddingTop: '10px' }}>
                    <PrimaryBtn onClick={handleAddToCompanyClick}>
                        {t('PROFILE.COMPANY.ADD_PARTNER')}
                    </PrimaryBtn>
                </Box>
            )}
        </Box>
    );
};
